export default __webpack_public_path__ + "static/media/nav-sprites.min.5fc6d325.webp";